import React, { useState } from "react";
import moment from "moment";
import { FetchAllActivities } from "../../lib/index.jsx";

function RecentActivity() {
	const { fetchingActivities, allActivities } = FetchAllActivities();
	const [showAll, setShowAll] = useState(false);

	const displayedActivities = showAll
		? allActivities
		: allActivities.slice(0, 5);

	return (
		<div className="flex flex-col gap-5 bg-[#FFFFFF] rounded-[8px] w-full md:w-[90%] shadow-md pt-6 p-4">
			<h1 className="text-[16px] font-[600] text-[#1E1E1E] font-jakarta">
				Recent Activity
			</h1>

			<div className="flex flex-col gap-2">
				{fetchingActivities ? (
					<p className="text-[#888] text-[13px] font-jakarta animate-pulse">
						Loading activities...
					</p>
				) : allActivities.length === 0 ? (
					<p className="text-[#888] text-[13px] font-jakarta">
						No recent activity found.
					</p>
				) : (
					<>
						{displayedActivities.map((recentActivity) => (
							<div
								className="border border-[#E5E7EB] p-2 rounded-[8px]"
								key={recentActivity.id}
							>
								<p className="text-[#1E1E1E] text-[12px]">
									{recentActivity.activityMessage}
								</p>
								<p className="text-[#002564] text-[11px]">
									{moment(recentActivity.createdAt).fromNow()}
								</p>
							</div>
						))}

						{allActivities.length > 5 && (
							<button
								onClick={() => setShowAll(!showAll)}
								className="text-blue-600 text-[12px] font-medium w-fit mt-2"
							>
								{showAll ? "Show Less" : "See More"}
							</button>
						)}
					</>
				)}
			</div>
		</div>
	);
}

export default RecentActivity;
